
import { defineComponent, onMounted, ref, watch } from "vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "evidence-list-drawer",
  components: {},
  props: {
    incoming: { type: Object, required: true },
    addedEvidences: { type: Array, required: true },
    drawer: Boolean,
  },
  emits: ["add-evidence", "add-custom", "close"],
  setup(props, { emit }) {
    const isCollapse = ref(false);

    // eslint-disable-next-line
    const libraryEvidence: any = ref([]);
    // eslint-disable-next-line
    const apiEvidence: any = ref([]);
    // eslint-disable-next-line
    const customEvidence: any = ref([]);

    onMounted(async () => {
      setTimeout(async () => {
        await getApiEvidence();
        await getCustomEvidence();
      }, 500);
    });

    watch(
      () => props.incoming,
      () => {
        getEvidenceLibrary();
      }
    );

    const getEvidenceLibrary = async () => {
      const { data } = await ApiService.get(
        `templates/evidence_pages?category=Library`
      );
      libraryEvidence.value = data.data;
    };

    const getApiEvidence = async () => {
      const { data } = await ApiService.get(
        "templates/evidence_pages?category=API"
      );
      apiEvidence.value = data.data;
    };

    const getCustomEvidence = async () => {
      const { data } = await ApiService.get(
        "templates/evidence_pages?category=Custom"
      );
      customEvidence.value = data.data;
    };

    const onAddLibrary = async (evidence) => {
      showProgress.value = true;
      if (props.addedEvidences.includes(evidence.id)) {
        // Remove Action
        try {
          const names = evidence.evidence_name.split(" ");
          const res = await ApiService.put(
            `chargebacks/incoming/${props.incoming.id}?action=remove_evidence&evidence_name=${props.incoming.case_number}_${evidence.id}_${names[0]}_${names[1]}.html`,
            {}
          );
          if (res.data.success) {
            emit("add-evidence");
            Swal.fire({
              position: "bottom",
              text: "Evidence Library Page Successfully removed!",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
            });
          } else {
            Swal.fire({
              text: res.data.error.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Try again!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          }
        } catch (e) {
          Swal.fire({
            text: e.response.data.error
              ? e.response.data.error.message
              : "Something went wrong!",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } else {
        // Add Action
        // eslint-disable-next-line
        const payload: any = { html: evidence.template_html };
        try {
          const names = evidence.evidence_name.split(" ");
          const res = await ApiService.put(
            `chargebacks/incoming/${props.incoming.id}?action=update_response_packet&evidence_name=${props.incoming.case_number}_${evidence.id}_${names[0]}_${names[1]}.html&active=1`,
            payload
          );
          if (res.data.success) {
            emit("add-evidence");
            Swal.fire({
              position: "bottom",
              text: "Evidence Library Page Successfully added!",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
            });
          } else {
            Swal.fire({
              text: res.data.error.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Try again!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          }
        } catch (e) {
          Swal.fire({
            text: e.response.data.error
              ? e.response.data.error.message
              : "Something went wrong!",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      }
      showProgress.value = false;
    };

    const onAddCustom = async (evidence) => {
      showProgress.value = true;
      if (props.addedEvidences.includes(evidence.id)) {
        // Remove action
        try {
          const names = evidence.evidence_name.split(" ");
          const res = await ApiService.put(
            `chargebacks/incoming/${props.incoming.id}?action=remove_evidence&evidence_name=${props.incoming.case_number}_${evidence.id}_${names[0]}_${names[1]}.html`,
            {}
          );
          if (res.data.success) {
            emit("add-evidence");
            Swal.fire({
              position: "bottom",
              text: "Custom Evidence Page Successfully removed!",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
            });
          } else {
            Swal.fire({
              text: res.data.error.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Try again!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          }
        } catch (e) {
          Swal.fire({
            text: e.response.data.error
              ? e.response.data.error.message
              : "Something went wrong!",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } else {
        // Add action
        if (evidence.evidence_name === "Custom Page") {
          try {
            const res = await ApiService.put(
              `chargebacks/incoming/${props.incoming.id}?action=custom_page&evidence_id=270`,
              {}
            );
            if (res.data.success) {
              emit("add-evidence");
              Swal.fire({
                position: "bottom",
                text: "Custom Page Successfully added!",
                icon: "success",
                showConfirmButton: false,
                timer: 2000,
              });
            } else {
              Swal.fire({
                text: res.data.error.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Try again!",
                customClass: {
                  confirmButton: "btn fw-bold btn-light-danger",
                },
              });
            }
          } catch (e) {
            Swal.fire({
              text: e.response.data.error
                ? e.response.data.error.message
                : "Something went wrong!",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Try again!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          }
        } else {
          emit("add-custom", evidence);
        }
      }
      showProgress.value = false;
    };

    const onAddAPI = async (evidence) => {
      showProgress.value = true;
      if (props.addedEvidences.includes(evidence.id)) {
        // Remove action
        try {
          const names = evidence.evidence_name.split(" ");
          const res = await ApiService.put(
            `chargebacks/incoming/${props.incoming.id}?action=remove_evidence&evidence_name=${props.incoming.case_number}_${evidence.id}_${names[0]}_${names[1]}.html`,
            {}
          );
          if (res.data.success) {
            emit("add-evidence");
            Swal.fire({
              position: "bottom",
              text: "API Evidence Page Successfully removed!",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
            });
          } else {
            Swal.fire({
              text: res.data.error.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Try again!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          }
        } catch (e) {
          Swal.fire({
            text: e.response.data.error
              ? e.response.data.error.message
              : "Something went wrong!",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } else {
        // Add action
        let url = "";
        switch (evidence.evidence_name) {
          case "Cardholder Address":
            url = `chargebacks/incoming/${props.incoming.id}?action=address_lookup&address=${props.incoming.transaction.address_1}, ${props.incoming.transaction.city}, ${props.incoming.transaction.state}, ${props.incoming.transaction.postal_code}&active=1`;
            break;
          case "Checkout Page":
            url = `chargebacks/incoming/${props.incoming.id}?action=merchant_checkout&active=1`;
            break;
          case "IP Geolocation":
            url = `chargebacks/incoming/${props.incoming.id}?action=ip_geolocation&active=1`;
            break;
          case "Merchant Landing":
            url = `chargebacks/incoming/${props.incoming.id}?action=merchant_landing&active=1`;
            break;
          default:
            break;
        }

        try {
          const res = await ApiService.put(url, {});
          if (res.data.success) {
            emit("add-evidence");
            Swal.fire({
              position: "bottom",
              text: "API Evidence Page Successfully added!",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
            });
          } else {
            Swal.fire({
              text: res.data.error.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Try again!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          }
        } catch (e) {
          Swal.fire({
            text: e.response.data.error
              ? e.response.data.error.message
              : "Something went wrong!",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      }
      showProgress.value = false;
    };

    const handleClose = () => {
      emit("close");
    };
    const activeName = ref(['2'])
    const showProgress = ref(false);

    return {
      isCollapse,
      libraryEvidence,
      customEvidence,
      apiEvidence,
      onAddLibrary,
      onAddCustom,
      onAddAPI,
activeName,
      handleClose,
      showProgress,
    };
  },
});
